// extracted by mini-css-extract-plugin
export default {"toolbar":"sidebar_toolbar__AQfdZ","support":"sidebar_support__Mnsn3","version":"sidebar_version__2b48o"};